import { useEffect } from 'react'
import { DEBUG_MODE } from '../../utilities/config'
import { DEBUG_TELEMETRY } from '../../utilities/telemetry'
import { isNullOrEmptyString } from '../../utilities/misc'

interface TelemetryConfig {
  web2UserId: string | undefined
  adminWeb2UserId: string | undefined
  isPlaying: boolean
  currentTrack?: string
  intervalMs?: number
}

export function useTelemetryPing({
  web2UserId,
  adminWeb2UserId,
  isPlaying,
  currentTrack = 'None',
  intervalMs = 30000,
}: TelemetryConfig) {
  useEffect(() => {
    if (DEBUG_TELEMETRY) console.log('tt-1')
    if (isNullOrEmptyString(web2UserId) || isNullOrEmptyString(adminWeb2UserId))
      return
    if (DEBUG_TELEMETRY) console.log('tt-2')
    if (web2UserId === adminWeb2UserId) return
    const endpoint: string = '/api/ps-t/s'
    let loopTracker: NodeJS.Timeout | null = null
    const getPayload = (isOfflineExplicit = false) => ({
      web2UserId: web2UserId,
      adminWeb2UserId: adminWeb2UserId,
      isPlaying: isOfflineExplicit ? false : isPlaying,
      currentTrack: isOfflineExplicit ? 'None' : currentTrack,
      isOfflineExplicit,
    })
    const sendPing = async () => {
      try {
        await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(getPayload(false)),
        })
      } catch (err: any) {
        if (DEBUG_MODE) console.error('Telemetry payload drop:', err)
      }
    }
    if (DEBUG_TELEMETRY) console.log('tt-3')
    const startLoop = (ms: number) => {
      if (loopTracker) clearInterval(loopTracker)
      loopTracker = setInterval(sendPing, ms)
    }
    sendPing()
    startLoop(intervalMs)
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        startLoop(60000)
      } else {
        sendPing()
        startLoop(intervalMs)
      }
    }
    const handlePageHide = () => {
      const payload = {
        web2UserId: web2UserId,
        adminWeb2UserId: adminWeb2UserId,
        isPlaying: false,
        currentTrack: 'None',
        isOfflineExplicit: true,
      }
      const blob = new Blob([JSON.stringify(payload)], {
        type: 'application/json',
      })
      navigator.sendBeacon(endpoint, blob)
    }
    document.addEventListener('visibilitychange', handleVisibilityChange)
    window.addEventListener('pagehide', handlePageHide)
    return () => {
      if (loopTracker) clearInterval(loopTracker)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      window.removeEventListener('pagehide', handlePageHide)
    }
  }, [web2UserId, adminWeb2UserId, isPlaying, currentTrack, intervalMs])
}
